import { render } from "./AdminDetails.vue?vue&type=template&id=e68a5c98&scoped=true"
import script from "./AdminDetails.vue?vue&type=script&lang=js"
export * from "./AdminDetails.vue?vue&type=script&lang=js"

import "./AdminDetails.vue?vue&type=style&index=0&id=e68a5c98&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e68a5c98"]])

export default __exports__